import { AdminLayout, useTranslation } from "@opendash/core";
import { Icon } from "@opendash/icons";
import { Button, Modal, Row, Space, Table, Tooltip, Typography } from "antd";
import type { ColumnsType } from "antd/es/table";
import { observer } from "mobx-react-lite";
import Parse from "parse";
import React, { useContext, useState } from "react";
import { LevelCreateDrawer } from "../../components/LevelCreateDrawer";
import { AgencyContext } from "../../contexts/AgencyContext";
import { useLevels } from "../../hooks/useLevels";
import { Level } from "../../js/parsegenerated";

interface DataType {
  level_index: number;
  level_name: string;
}

export const LevelPage = observer(() => {
  const t = useTranslation();
  const state = useContext(AgencyContext);
  const [createDrawerVisible, setCreateDrawerVisible] = useState(false);
  const [levels, reloadLevels] = useLevels();
  const { Title } = Typography;
  const { confirm } = Modal;

  const columns: ColumnsType<DataType> = [
    {
      title: "Index",
      dataIndex: "index",
      key: "index",
      render: (_, level: Level) => (level ? level.get("level_index") : ""),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (_, level: Level) => (level ? level.get("level_name") : ""),
    },
    {
      title: "Aktionen",
      dataIndex: "actions",
      key: "actions",
      render: (_, level: Level) => (
        <Space size="small">
          <Tooltip
            title={t(
              "gtfs:administration.levels.manage.table.columns.actions.delete.tooltip"
            )}
          >
            <Button
              shape="circle"
              onClick={() => {
                confirm({
                  title: t(
                    "gtfs:administration.levels.manage.table.columns.actions.delete.confirm.title"
                  ),
                  icon: <Icon icon="fa:exclamation"></Icon>,
                  content: t(
                    "gtfs:administration.levels.manage.table.columns.actions.delete.confirm.content"
                  ),
                  okText: t("gtfs:global.button.ok_label"),
                  okType: "danger",
                  cancelText: t("gtfs:global.button.cancel_label"),
                  onOk() {
                    deleteconfirm(level);
                  },
                  onCancel() {},
                });
              }}
              icon={
                <Icon
                  icon="fa:trash"
                  key="delete"
                  style={{ color: "#ff4d4d" }}
                />
              }
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const deleteconfirm = async (level: Level) => {
    //Set pointer in all stops auf undefined
    // const stopswithlevel = await new Parse.Query(Stop)
    //   .equalTo("level_id", {
    //     className: Level.className,
    //     __type: "Pointer",
    //     objectId: level.id,
    //   })
    //   .find();

    //Destroy level
    await (await new Parse.Query(Level).get(level.id)).destroy();
    reloadLevels();
  };

  const onOkCreate = () => {
    setCreateDrawerVisible((current) => !current);
    reloadLevels();
  };

  return (
    <>
      <AdminLayout contentPadding>
        <Row justify="space-between">
          <Title level={3} style={{ marginBottom: "15px" }}>
            {t("gtfs:administration.levels.manage.headline")}
          </Title>
          <Button type="primary" onClick={() => setCreateDrawerVisible(true)}>
            {t("gtfs:administration.levels.manage.add")}
          </Button>
        </Row>
        <Table
          size="middle"
          rowKey={(level: Level) => level.id}
          columns={columns}
          dataSource={levels}
        />
      </AdminLayout>

      <LevelCreateDrawer open={createDrawerVisible} onOk={onOkCreate} />
    </>
  );
});
